import styled from '@emotion/styled';
import type { BadgeProps, DefaultMantineColor } from '@mantine/core';
import { Badge } from '@mantine/core';
import React, { type ComponentPropsWithoutRef } from 'react';

export type StatusBadgeProps = {
	className?: string;
	status: 'draft' | 'changed' | 'published' | 'required' | 'managed' | 'unmanaged' | 'archived';
	onClick?: () => void;
};

const STATUS_COLORS: Record<StatusBadgeProps['status'], DefaultMantineColor> = {
	draft: 'gray',
	changed: 'yellow',
	published: 'green',
	required: 'cyan',
	managed: 'green',
	unmanaged: 'grey',
	archived: 'red',
};

const STATUS_TEXT: Record<StatusBadgeProps['status'], string> = {
	draft: 'Draft',
	changed: 'Changed',
	published: 'Published',
	required: 'Mandatory',
	managed: 'Managed',
	unmanaged: 'Un-managed',
	archived: 'Archived',
};

export default function StatusBadge(props: StatusBadgeProps) {
	const { className, status, onClick } = props;

	return (
		<StyledBadge
			className={`StatusBadge ${onClick ? 'pointer' : ''} ${className ?? ''}`}
			color={STATUS_COLORS[status]}
			onClick={onClick}
		>
			{STATUS_TEXT[status]}
		</StyledBadge>
	);
}

export const StyledBadge = styled(Badge)<BadgeProps & ComponentPropsWithoutRef<'div'>>`
	&.pointer {
		cursor: pointer;
	}
	.mantine-Badge-label {
		overflow: visible;
	}
`;
